import { useState, useRef } from "react"
import { PropTypes } from "prop-types"
import classNames from "classnames"
import _ from "lodash"
import isTouchDevice from "is-touch-device"

import ClearButton from "../ClearButton"
import errorPropTypes from "../errorPropTypes"

export function FieldInput(props) {
  const {
    children,
    id,
    value,
    onBlur,
    onClear,
    error = {},
    isClearable = false,
    readOnly = false,
    ...rest
  } = props
  const { key, hasError } = error
  const errorId = `${id}-error`
  const fieldRef = useRef()
  const clearFieldEnabled = isClearable && value && !readOnly && !key
  const [showClearButton, setShowClearButton] = useState(false)
  const setShowClearButtonDebounced = _.debounce(
    display => fieldRef.current && setShowClearButton(display),
    100
  )
  const touchableDevice = isTouchDevice()

  return (
    <div
      className={classNames("oj-field-input", {
        clearable: showClearButton && clearFieldEnabled && touchableDevice
      })}
      ref={fieldRef}
    >
      {typeof children === "function"
        ? children({
            id,
            errorId,
            hasError,
            readOnly,
            value,
            onBlur: e => {
              setShowClearButtonDebounced(false)

              onBlur && onBlur(e)
            },
            onFocus: () => setShowClearButtonDebounced(true),
            ...rest
          })
        : children}
      {showClearButton && clearFieldEnabled && <ClearButton onClick={onClear} />}
    </div>
  )
}

FieldInput.propTypes = {
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
  error: PropTypes.shape(errorPropTypes),
  id: PropTypes.string,
  isClearable: PropTypes.bool,
  readOnly: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onBlur: PropTypes.func,
  onClear: PropTypes.func
}

export default FieldInput
